class BlockListApi {
    constructor(DoclrHttp, praktijkContext) {
        'ngInject';

        this.praktijkContext = praktijkContext;
        this.DoclrHttp = DoclrHttp;
    }

    create(newPersonBlock) {
        return this.DoclrHttp.post(this.getListUrl(newPersonBlock.personId), newPersonBlock);
    }

    setActive(personBlock){
        return this.DoclrHttp.post(this.getUniqueUrl(personBlock.id, personBlock.personId) + "/set-active");
    }

    setInActive(personBlock){
        return this.DoclrHttp.post(this.getUniqueUrl(personBlock.id, personBlock.personId) + "/set-inactive");
    }

    findAll(personId) {
        return this.DoclrHttp.get(this.getListUrl(personId));
    }

    remove(id, personId) {
        return this.DoclrHttp.delete(this.getUniqueUrl(id, personId));
    }

    getListUrl(personId) {
        return `/apiv0/party/${this.praktijkContext.id}/person/${personId}/person-block`;
    }

    getUniqueUrl(id, personId) {
        return `${this.getListUrl(personId)}/${id}`;
    }

}

(function () {
    'use strict';

    angular.module('doclr.blocklist')
        .service('BlockListApi', BlockListApi)
})();